<template src="./registration_excel.html"></template>
<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "registration_excel",
    data() {
      return {
        
        optionList : [],
        
        files: [],              // 파일 데이터
        fileUrl: `${process.env.VUE_APP_API_URL}/file`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('srAccessToken')}`,
          'Access-Control-Allow-Origin': '*',
        },
        aggregator_id : null,
        accept:"",
        extensions:'',
        multiple: false,
        directory: false,
        drop: true,
        dropDirectory: true,
        addIndex: false,
        thread: 3,
        
        uploadAuto: false,
      }
    },
    watch:{
      
    },
    mounted(){
      this.$nextTick(()=>{
        this.callList()
      })
    },
    methods: {
      callList(){
        this.loadingShow()
        this.$store.dispatch('GET_AGGREGATOR')
        .then(result =>{
            this.loadingHide()
            this.optionList  = result // 권리자 목록
        }).catch(error=>{
            const status = error.response.status
            this.loadingHide()
            switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                    this.alert({msg : error.response.data.message})
                break;
            }
        })
      },
    
     
      all_save(){
        this.closeModal('confirm')
        if(this.valCheck(this.aggregator_id)){
          this.alert({msg:'계약사를 선택해주세요.'});
          return false
        }
        if(this.files.length < 1) {
          this.alert({msg:'파일을 등록해주세요'});
          return false
        }
        
        const params = {
          aggregator_id : this.aggregator_id,
        }
        console.log(this.files[0].name)
        if(this.files[0].file.name.indexOf('csv') < 0){
          this.alert({msg:'csv파일만 등록 가능합니다. 파일을 확인해주세요.'});
          return false
        }
        
        const payload = {
          file: this.files[0].file,
          params: params
        }
        this.loadingShow()
        this.$store.dispatch("POST_SALESLINEGROUP", payload)
        .then(result =>{
          this.loadingHide()
          this.alert({msg:'로그 업로드 요청을 성공하였습니다. <br/> 작업이 완료되면 알림(slack)으로 전송 될 것입니다.'})
          this.historyBack()
        }).catch(error =>{
          this.loadingHide()
          const errorCode = error.response.data.code
          switch(errorCode){
           
            default:
              this.alert({
                msg: error.response.data.message,
              })
              break;
          }

        })
      },
      
      handleRemove(file, fileList){
        this.file = null
      },
      handleChange(file, fileList){
        this.file = file.raw
        this.fileList = []
        this.fileList.push(fileList[fileList.length-1])
      },
      closeOpen(modalNo){
        return new Promise(resolve =>{
          resolve(this.modals[modalNo] = false)
        })
      },
    }
}
</script>

<style  lang="scss" scoped>


.el-upload-dragger {
  background: transparent !important;
  background-color: #000 !important;
}
.el-upload {
  width: 100%;
}

</style>